import axios from 'axios';

const BASE = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: `${BASE}/api`,
  headers: { 'Content-Type': 'application/json' },
});

// Attach JWT to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('lms_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Global 401 handler
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('lms_token');
      localStorage.removeItem('lms_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;

export const psrReportAPI = {
  getMyReports: ()         => api.get('/psr-reports/my-reports'),
  // FormData requires browser to set multipart boundary — delete default Content-Type
  saveReport:   (formData) => api.post('/psr-reports/save', formData, {
    headers: { 'Content-Type': undefined },
  }),
  getPending:   ()         => api.get('/psr-reports/pending-review'),
  review:       (formData) => api.post('/psr-reports/review', formData, {
    headers: { 'Content-Type': undefined },
  }),
};

export const jobTimelineAPI = {
  getMyTimeline: ()     => api.get('/job-timeline/my-timeline'),
  saveEntry:     (data) => api.post('/job-timeline/save', data),
  deleteEntry:   (data) => api.post('/job-timeline/delete', data),
};

export const supervisorAPI = {
  getMyEmployees:   ()     => api.get('/sync/supervisor-employees'),
  assignEmployee:   (data) => api.post('/sync/assign-employee', data),
  removeAssignment: (data) => api.post('/sync/remove-assignment', data),
};
